import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export function visitorId() {
  try {
    let v = localStorage.getItem("cc_vid");
    if (!v) {
      v = (window.crypto?.randomUUID ? window.crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36)).replace(/-/g, "");
      localStorage.setItem("cc_vid", v);
    }
    return v;
  } catch (e) { return null; }
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const vid = visitorId();
  if (vid) config.headers["X-CC-Visitor"] = vid;
  return config;
});

export default api;
